'use strict';

class GrpFeeListCtrl {
  // data will hold the list of group fees
  data = [];

  constructor($stateParams, LoaderSvc, GrpFeeSvc, GroupAuthSvc) {
    LoaderSvc.start('Loading Group Fees...');
    var that = this;
    var ctxId = $stateParams.ctxId;
    this.ctxId = ctxId; // set for group urls
    var groupId = $stateParams.groupId;
    this.groupId = Number(groupId); // convert to number for disable link check

    // authorization
    GroupAuthSvc.validatePermission(this.groupId, 'groupFee', 'I');

    that.dataModel = 'gfvm';
    GrpFeeSvc.getDefinedFor({groupId}).$promise
      .then(function(data) {
        that.data = data;
        that.order = 'name';
        that.searchField = 'name';
        LoaderSvc.stop();
      })
      .catch(function() { LoaderSvc.stopError('Error loading Group Fees'); });
  }
}

GrpFeeListCtrl.$inject = [
  '$stateParams',
  'LoaderSvc',
  'GrpFeeSvc',
  'GroupAuthSvc'
];

export default GrpFeeListCtrl;
